// extracted by mini-css-extract-plugin
export default {"siteloader":"siteloader_siteloader__GqBlJ","main":"siteloader_main__dlrv0","center":"siteloader_center__actvJ","middle":"siteloader_middle__kJumU","top":"siteloader_top__M4HU4"};